import { Component } from '@angular/core';
import { ServiceRequestService } from '../services/service.request.service';

@Component({
  selector: 'app-service-request-history-pagination',
  templateUrl: './service-request-history-pagination.component.html'
})
export class ServiceRequestHistoryPaginationComponent {
  constructor(public service: ServiceRequestService) { }

  onPaginate(page: number) {
    this.service.currentPage = page;
    this.service.getHistory();
  }
}
